import React, {forwardRef, MutableRefObject, useEffect, useState} from "react";
import { Input } from "@rebass/forms";
import {FieldHelperProps, FieldInputProps, FieldMetaProps, useField} from "formik";
import {InputHelper, InputHelperOptionalParameters} from "./InputHelper";
import {Moment} from "moment";
import styled from "styled-components";

export const ParagraphInput: React.FC<{
  name: string;
  errorText?: string;
  helperParameters?: InputHelperOptionalParameters;
  allowEmpty?: boolean;
}> = ({name, errorText, helperParameters= {label: name}, allowEmpty=false}) => {
  const validate = (value) => {
    if (value === "" && !allowEmpty) {
      return errorText || "Select a value";
    }
  };

  const [field, meta, helpers] = useField({ name, validate });

  return (
    <InputHelper meta={meta} helpers={helpers} {...helperParameters}>
      <TextArea value={meta.value} setValue={helpers.setValue}/>
    </InputHelper>
  );
};


export const TextArea = forwardRef(
  (
    {value, setValue, onBlur}: {
      value: string;
      setValue: (string) => void;
      onBlur?: (FocusEvent) => void;
      },
    ref
  ) => {
    const placeholder = "Type here..."
    const width = (2 + Math.max(value?.length || 0, placeholder.length)) * 9

    return (
      <StyledTextarea
        cols={35}
        rows={6}
        onBlur={(e) => {if (onBlur) onBlur(e)}}
        onChange={(e) => {
          setValue(e.target.value)
        }}
        onKeyDown={(e) => { // @ts-ignore
          if (e.code === "Enter") e.target.blur()
        }}
        value={value /* @ts-ignore */}
        placeholder={placeholder}
      />
    )
  }
)

export const StyledTextarea = styled.textarea<{}>`
  resize: none;
  border: 0;
  padding: 4px;
  outline: 1px solid #dddddf;
  //border-bottom: 2px solid #dddddf;
  font-size: 16px;
  &:focus {
    //outline: 1px solid #dddddf;
  }
`
